export enum eBusinessType {
  individual = 2,
  company = 1
}
